import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { canAccessAdminPath, getDefaultAdminRoute, isAdminPanelRole } from '../../utils/adminRoles';

/**
 * Admin-only route guard.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components to render if admin
 * @param {string} props.redirectTo - Path to redirect to if not authorized
 */
function AdminRoute({ children, redirectTo = '/', requiredPath = '/admin' }) {
    const { currentUser, userRole, loading } = useAuth();

    if (loading) {
        return null;
    }

    if (!currentUser || !isAdminPanelRole(userRole)) {
        return <Navigate to={redirectTo} replace />;
    }

    if (!canAccessAdminPath(userRole, requiredPath)) {
        return <Navigate to={getDefaultAdminRoute(userRole)} replace />;
    }

    return <>{children}</>;
}

export default AdminRoute;
